export default "__VITE_ASSET__g7g3b57T__"